import { NgModule } from "@angular/core";
import { MessageComponent } from "./message.component";
import { MessageService } from "./message.service";
import { CommonModule } from "@angular/common";
import { SafeHtmlPipe } from "projects/brandmonitor-browser-extension/src/app/pipes/safe-html.pipe";

@NgModule({
  declarations: [
    MessageComponent,
    SafeHtmlPipe
  ],
  imports: [CommonModule],
  exports: [MessageComponent],
  providers: [MessageService]
})
export class MessageModule {}
